import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { Progress, Row, Col, Table, Button } from 'reactstrap';
import { Link } from 'react-router'

import Loader from '../../core/components/Loader'

import Arrow from 'react-icons/lib/fa/chevron-circle-right'

import '../styles/leads.css'
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css'




class TaskList extends React.Component {

    constructor(props) {
	    super(props);

	    this.state = {
	    	responsive:false
	    }

	    this.options = {
	      hideSizePerPage:true
	    };
	}


	componentDidMount() {
	    this.props.listTask(this.props.date)

	    if( window.innerWidth < 520){
	    	this.setState({responsive:true})
	    }
	}


	taskFormatter(cell, row, enumObject, index) {
		return (
			<div className="task-formatter">
			    <Link to={"/manager/prestataire/"+row.id} > <Arrow /> {cell} </Link>
			</div>
		);
	}

	managerFormatter(cell, row, enumObject, index) {
		return (
			<div className="managerFormatter">
			    {cell.join(',')}
			</div>
		);
	}


	renderTask(){
		const { task } = this.props

		return(
			<div className="table-list-lead table-list-task">
				{!this.state.responsive && 
					<BootstrapTable ref='table' data={task.list} options={this.options} pagination>
			            <TableHeaderColumn dataField='task' isKey={true} dataSort={true} dataFormat={this.taskFormatter}> Catégorie </TableHeaderColumn>
			            <TableHeaderColumn dataField='company' dataSort={true} > Prestataire </TableHeaderColumn>
			            <TableHeaderColumn dataField='updated_at' dataSort={true} > Candidature </TableHeaderColumn>
			            <TableHeaderColumn dataField='manager' dataSort={true} dataFormat={this.managerFormatter}> Responsable </TableHeaderColumn>
			        </BootstrapTable>
		    	}

		    	{this.state.responsive && 
					<BootstrapTable ref='table' data={task.list} options={this.options} pagination>
			            <TableHeaderColumn dataField='task' isKey={true} dataSort={true} dataFormat={this.taskFormatter}> Catégorie </TableHeaderColumn>
			            <TableHeaderColumn dataField='updated_at' dataSort={true} > Candidature </TableHeaderColumn>
			        </BootstrapTable>
		    	}
	        </div>
		)
	}


    render() {
    	const { task } = this.props

    	return (
            <div>

            	<div className="leads-header">
	            	<Row>
	            		<Col>

	            			<div className="leads-total"> {task.list.length} tâche(s) </div>

	            		</Col>

	            	</Row>
            	</div>

            	{task.fulfilled &&
            		this.renderTask()
            	}

            	{task.pending &&
            		<Loader />
            	}
               	
            </div>
        )
    }
}


export default TaskList



// WEBPACK FOOTER //
// ./src/lead/components/TaskList.js